import { Notification } from '@smartgift/frontend-toolkit';
import dayjs from 'dayjs';
import React from 'react';
import { Trans } from 'react-i18next';

import { SkeletonLoaders } from '@hero/components';
import { RECOGNITION_STATUSES, dateLabelFormatDay } from '@hero/constants';
import { formatCurrency } from '@hero/utils';

function CcPaymentNotifications({ authorization, status, refund, isFetching }) {
  if (isFetching) {
    return <SkeletonLoaders.CCPaymentRefundNotification />;
  }

  if (status === RECOGNITION_STATUSES.expired) {
    const estimatedRefundDate = dayjs(refund?.estimatedAt).format(dateLabelFormatDay);

    return (
      <Notification
        status="info"
        message={
          <Trans
            i18nKey={
              dayjs().isAfter(dayjs(refund?.estimatedAt))
                ? 'remainingRefunded'
                : 'remainingWillBeRefunded'
            }
            values={{
              amount: formatCurrency(refund?.total),
              refundDate: estimatedRefundDate
            }}
            components={{ b: <b /> }}
          />
        }
      />
    );
  }
  return (
    <Notification
      status="info"
      message={
        <Trans
          i18nKey="authorizeAmountInfoCostSummary"
          values={{ amount: formatCurrency(authorization?.total) }}
          components={{ b: <b /> }}
        />
      }
    />
  );
}

export { CcPaymentNotifications };
